import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, labelModes, popperPlacements, sizes } from '@/utils'

import button from '@/components/button'
import tag from '@/components/tag'

function renderEdgeArrow(h, options) {
  if (this.arrows && this.edgeArrows && this.viewport.breakpoint.mdUp) {
    return h(
      button,
      {
        props: {
          icon: options.icon,
          mode: buttonModes.flat,
          size: sizes.medium,
          disabled: options.disabled
        },
        on: {
          click: () => {
            this.setPage(options.page)
          }
        }
      }
    )
  }
}

function renderArrow(h, options) {
  if (this.arrows) {
    return h(
      button,
      {
        props: {
          icon: options.icon,
          mode: buttonModes.flat,
          size: sizes.medium,
          disabled: options.disabled
        },
        on: {
          click: () => {
            this.setPage(options.page)
          }
        }
      }
    )
  }
}

function renderPages(h) {
  return this.pages.map(page => {
    const isCurrentPage = this.currentPage === page
    let mode = buttonModes.filled
    let color
    if (isCurrentPage) {
      color = Colors.primary
    } else {
      mode = buttonModes.flat
    }

    return h(
      button,
      {
        props: {
          label: page,
          size: sizes.medium,
          mode,
          color
        },
        on: {
          click: () => {
            this.setPage(page)
          }
        }
      }
    )
  })
}

function renderLimitField(h) {
  if (this.isAdmin) {
    return h(
      'div',
      {
        class: 'flex grid-gap--8 pa-2'
      },
      [
        h(
          components['text-field'],
          {
            props: {
              value: this.limit,
              labelMode: labelModes.hidden,
              dense: true,
              details: false,
              type: 'number',
              mask: /^\d{0,3}$/,
              min: 1,
              max: 100,
              step: 1,
              processValue: value => {
                if (value === '' || value === null || value === undefined) {
                  return ''
                }
                const n = parseInt(String(value).replace(/\D+/g, ''), 10)
                if (isNaN(n)) {
                  return ''
                }

                return Math.max(1, Math.min(100, n))
              }
            },
            on: {
              input: value => {
                this.limit = value
              }
            }
          }
        ),

        h(
          button,
          {
            props: {
              icon: icons.done,
              mode: buttonModes.flat,
              color: Colors.primary,
              disabled: !this.limit || this.limit === this.proxy.limit
            },
            on: {
              click: () => {
                const clamped = Math.max(1, Math.min(100, Number(this.limit)))
                this.limit = clamped
                this.proxy.limit = clamped
                this.saveLimit(clamped)
              }
            }
          }
        )
      ]
    )
  }
}
function renderSelectRowsList(h) {
  return h(
    components.list,
    {
      props: {
        dense: true,
        rounded: true
      }
    },
    [
      this.rowsPerPage.map(rows => {
        return h(
          components['list-item'],
          {
            props: {
              active: this.proxy.limit === rows,
              dense: true
            },
            on: {
              click: () => {
                this.setPage(1, rows)
              }
            }
          },
          [ rows ]
        )
      })
    ]
  )
}
function renderSelectRowsContent(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [
      renderSelectRowsList.call(this, h),
      renderLimitField.call(this, h)
    ]
  )
}
function renderSelectRows(h) {
  if (this.proxy.total) {
    if (this.selectRows) {
      if (this.viewport.size.width > 320) {
        let width = '80px'
        if (this.isAdmin) {
          width = '120px'
        }

        return h(
          components.menu,
          {
            props: {
              value: this.showMenu,
              rounded: true,
              placement: popperPlacements['bottom-end'],
              offsetDistance: 8,
              closeOnContentClick: false,
              width
            },
            on: {
              input: event => {
                this.showMenu = event
              }
            }
          },
          [
            h(
              button,
              {
                props: {
                  label: this.proxy.limit,
                  icon: icons.list,
                  size: sizes.medium,
                  color: Colors.primary
                },
                slot: 'activator'
              }
            ),
            renderSelectRowsContent.call(this, h)
          ]
        )
      }
    }
  }
}

function renderTotal(h) {
  if (this.proxy.total) {
    return h(
      tag,
      {
        props: {
          as: 'button',
          label: this.proxy.total,
          size: sizes.huge,
          color: Colors.primary,
          monospace: true
        }
      }
    )
  }
}

export default function(h) {
  if (this.show) {
    if (this.proxy.total > this.proxy.limit) {
      return h(
        'div',
        {
          class: 'grid grid-gap--8',
          style: { 'grid-template-columns': this.buttonColumnsStyle }
        },
        [
          renderEdgeArrow.call(
            this,
            h,
            {
              icon: icons.first_page,
              page: 1,
              disabled: this.proxy.offset === 0
            }
          ),

          renderArrow.call(
            this,
            h,
            {
              icon: icons.keyboard_arrow_left,
              page: this.currentPage - 1,
              disabled: this.proxy.offset === 0
            }
          ),

          renderPages.call(this, h),

          renderArrow.call(
            this,
            h,
            {
              icon: icons.keyboard_arrow_right,
              page: this.currentPage + 1,
              disabled: this.proxy.offset + this.proxy.limit >= this.proxy.total
            }
          ),

          renderEdgeArrow.call(
            this,
            h,
            {
              icon: icons.last_page,
              page: this.totalPages,
              disabled: this.proxy.offset + this.proxy.limit >= this.proxy.total
            }
          ),

          renderSelectRows.call(this, h),

          renderTotal.call(this, h)
        ]
      )
    } else {
      return h(
        'div',
        {
          class: 'flex grid-gap--8'
        },
        [
          renderSelectRows.call(this, h),
          renderTotal.call(this, h)
        ]
      )
    }
  }
}
